export default __webpack_public_path__ + "static/media/ci_crates.99d13d34.png";